import { render } from "./App.vue?vue&type=template&id=3720d92a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3720d92a&lang=scss"
script.render = render

export default script